
    import { Component, Vue, Prop } from 'vue-property-decorator';

    @Component
    export default class questionsResult extends Vue {
        @Prop({ required: true }) readonly results!: any
    }
